import { Dimensions } from '../../consts';
import { getCohortFieldAndPeriod, MetricsMap } from '../../metricsUtils';
import { mapFieldsToMultiValuedStructure } from '../../creativesFormattingUtils';

export const BREAKDOWN_DIMENSIONS = {
    COUNTRY: { value: Dimensions.COUNTRY, label: 'Country' },
    OS: { value: Dimensions.OS, label: 'OS' },
    CAMPAIGN_NAME: { value: Dimensions.CAMPAIGN_NAME, label: 'Campaign' },
    DATE: { value: Dimensions.DATE, label: 'Date' },
    CREATIVE_ORIENTATION: { value: Dimensions.CREATIVE_ORIENTATION, label: 'Orientation' },
    CREATIVE_ASPECT_RATIO: { value: Dimensions.CREATIVE_ASPECT_RATIO, label: 'Aspect Ratio' },
    CREATIVE_VIDEO_DURATION: { value: Dimensions.CREATIVE_VIDEO_DURATION, label: 'Video Duration' },
};

export const DIMENSION_OPTIONS = [
    BREAKDOWN_DIMENSIONS.COUNTRY,
    BREAKDOWN_DIMENSIONS.CAMPAIGN_NAME,
    BREAKDOWN_DIMENSIONS.OS,
];

export const BreakdownType = {
    TABS: 'tabs',
    DROPDOWN: 'dropdown',
};

export const CHART_METRIC_KEYS = ['custom_impressions', 'custom_clicks', 'custom_installs', 'ipm'];

export const CHART_COHORT_METRICS = [
    { name: 'roi', fallback_label: 'ROI', display_format: { type: 'percentage', precision: 2 } },
];

export const OVERVIEW_MULTI_VALUED_FIELDS = mapFieldsToMultiValuedStructure([
    Dimensions.CREATIVE_ID,
    Dimensions.CREATIVE_NAME,
    Dimensions.ASSET_ID,
    Dimensions.ASSET_NAME,
    Dimensions.CAMPAIGN_NAME,
    Dimensions.CAMPAIGN_ID,
]);

export const OVERVIEW_METRICS = [
    MetricsMap.CUSTOM_IMPRESSIONS,
    MetricsMap.CUSTOM_CLICKS,
    MetricsMap.CUSTOM_INSTALLS,
    MetricsMap.COST,
    MetricsMap.IPM,
    MetricsMap.CVR,
    MetricsMap.CTR,
];

export const OVERVIEW_COHORT_METRICS = [{ value: 'revenue_actual' }];

export const HIDDEN_OVERVIEW_FIELDS = new Set([
    ...OVERVIEW_COHORT_METRICS.map(({ value }) => getCohortFieldAndPeriod(value)[0]),
]);

export const DEFAULT_COL_DEF = {
    sortable: true,
    resizable: true,
    minWidth: 80,
    flex: 1,
};

export const SIMILAR_CREATIVES_KEYS_PREFIX = 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.SIMILAR_CREATIVES';

export const SimilarCreativesKeys = {
    TITLE: 'TITLE',
    TAB_SUBTITLE: 'SUBTITLE',
    LOADING_SUBTITLE: 'LOADING',
    NO_DATA_MESSAGE: 'NO_DATA',
    ERROR_MESSAGE: 'ERROR',
    OVERVIEW_TITLE: 'OVERVIEW',
    SPEC_ANALYSIS_TITLE: 'SPEC_ANALYSIS',
    SCATTER_ANALYSIS_TITLE: 'SCATTER_ANALYSIS',
    TAG_ANALYSIS_TITLE: 'TAG_ANALYSIS',
    X_AXIS_LABEL: 'X_AXIS',
    Y_AXIS_LABEL: 'Y_AXIS',
    AI_DIMENSION_LABEL: 'AI_DIMENSION',
    METRIC_LABEL: 'METRIC',
    CREATIVES_LABEL: 'CREATIVES',
    SAME_VALUE_MESSAGE: 'SAME_VALUE',
};

export const SIMILAR_CREATIVES_TAB_TITLE = 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.SIMILAR_CREATIVES_TAB';
